export const DynamicMessageTypeEnum = {
    Warn: 1,
    Error: 2,
    NoEnter: 3
}